import React, { useContext} from "react";
import {
  addToAlreadyCreatedId,
  checkControlIdExistance,
  deleteControlIdFromExistance,
} from "../IFormDesignerLogic";

import { AppContext } from "../../../Resources/CanvasContextFile";


// formstate boolean variable for precedence

// precedence 0 , like before | mapping id > user defined
// precedence 1 | mapping id < user defined

export function updateUserId(component_json, userDefinedId) {
  let component = { ...component_json };
  // console.log("updateUserId ==> ", component_json, userDefinedId);
  let prevId = component["style"]["CustomId"];
  // console.log("prevId :: ", prevId);
  try {
    //now checking the existance of newly userDefinedId
    //if new userDefinedId is not already present then add / else not
    if (!checkControlIdExistance(userDefinedId)) {
      addToAlreadyCreatedId(userDefinedId);
      component["style"]["CustomId"] = userDefinedId;
      //deleting the previous id after adding the new one
      deleteControlIdFromExistance(prevId);
    }
    return component;
  } catch (error) {
     //console.log("Error :: ", error);
    return undefined;
  }
}

export function getSuggestedId(actualControlId, mappingId, userDefinedId, IdPrecedence) {
  let suggestedId;
  const isIBPSClient = window?.psh_configs?.isIBPSClient || false;
  if (IdPrecedence === undefined || IdPrecedence === null) {
    IdPrecedence = 0;
  }
  if (IdPrecedence === 0) {
    if (mappingId) {
      suggestedId = mappingId;
    } else if (userDefinedId) {
      suggestedId = userDefinedId;
    } else {
      suggestedId = actualControlId;
    }
  } else {
    if (userDefinedId) {
      suggestedId = userDefinedId;
    } else if (mappingId) {
      suggestedId = mappingId;
    } else {
      suggestedId = actualControlId;
    }
  }
  // console.log("suggestedId :: ", suggestedId);
  return suggestedId === mappingId && isIBPSClient ? suggestedId?.replaceAll(".", "_") : suggestedId;
}
